<template>
  <div>
    <!--表格区域-->
    <el-row>
      <el-col :span="24">
        <el-table
          :data="list"
          size="small"
          border
        >
          <el-table-column label="姓名" prop="customer_name" align="center"/>
          <el-table-column label="手机号" prop="telephone" align="center"/>
          <el-table-column label="门店" prop="shop_name" align="center"/>
          <el-table-column label="卡项名称" prop="name" align="center"/>
          <el-table-column label="开卡时间" prop="create_time" align="center"/>
          <el-table-column label="类型" prop="service_type" align="center">
            <template slot-scope="scope">
              {{scope.row.service_type == 1 ? '按天' : '按次'}}
            </template>
           </el-table-column>
           <el-table-column label="开始时间" prop="start_time" align="center"/> <el-table-column label="结束时间" prop="end_time" align="center"/>
          <el-table-column label="实付本金" prop="consume_money" align="center"/>
          <el-table-column label="实付赠金" prop="consume_gratuity" align="center"/>
          <el-table-column label="实付店转" prop="consume_store_transfer" align="center"/>
          <el-table-column label="开卡次数" prop="num" align="center"/>
          <el-table-column label="有效期" prop="indate" align="center"/>
          <el-table-column label="剩余次数" prop="residue_num" align="center"/>
          <el-table-column label="剩余本金" prop="residue_bj" align="center"/>
          <el-table-column label="剩余赠金" prop="residue_zj" align="center"/>
          <el-table-column label="剩余店转" prop="residue_dz" align="center"/>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getZyCustomerDetails } from "@/api/statistics";

export default {
  name: "CardDetailList",
  components: {
  },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 根据路由id请求卡项详情列表
    getList() {
      getZyCustomerDetails({
        shop_id:  parseInt(this.$route.query.shop_id),
        customer_id : parseInt(this.$route.query.customer_id),
      }).then(res => {
        this.list = res.data.list || [];
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mt10 {
  margin-top: 10px;
}
.tc {
  text-align: center;
}
</style>